import Ayah from './Ayah';
import Ibu from './Ibu';
import Kendaraan from './Kendaraan';
import Listrik from './Listrik';
import Pendukung from './Pendukung';
import Pribadi from './Pribadi';
import Rumah from './Rumah';
import Wali from './Wali';

export {
    Ayah,
    Ibu,
    Kendaraan,
    Listrik,
    Pendukung,
    Pribadi,
    Rumah,
    Wali
};